import { useCallback, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { FiatCurrency } from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import { handleGetExchangeRates } from "../../api-clients/walletsExchangeRatesClient";
import { queryClient } from "../query-client";
import Logger from "../../utils/logger";

const exchangeRatesQueryOptions = {
  queryKey: [QUERY_KEYS.WALLET.EXCHANGE_RATES],
  queryFn: handleGetExchangeRates,
} as const;

export function prefetchExchangeRates() {
  return queryClient.prefetchQuery(exchangeRatesQueryOptions);
}

function useExchangeRatesQuery() {
  const query = useQuery(exchangeRatesQueryOptions);

  useEffect(() => {
    if (!query.isError) return;

    Logger.error({
      message: "Failed to fetch exchange rates",
      queryKey: exchangeRatesQueryOptions.queryKey,
      error: query.error,
    });
  }, [query.error, query.isError]);

  const getExchangeRate = useCallback(
    (currency: FiatCurrency) => {
      if (!query.data) return;

      const exchangeRates = query.data;

      if (currency === FiatCurrency.NGN) {
        return exchangeRates.ngn;
      }

      return exchangeRates.usd;
    },
    [query.data]
  );

  return {
    query,
    getExchangeRate,
  };
}

export default useExchangeRatesQuery;
